import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import BackButton from "@/components/BackButton";

export default function StudentCourses() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/enrollments/me");
      setItems(data);
      setLoading(false);
    })();
  }, []);
  return (
    <div className="p-6 md:p-10">
      <BackButton />
      <div className="mt-5 mb-8">
        <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
          /my courses
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">
          My Courses
        </h1>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-48 animate-pulse border border-border bg-muted" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <div className="border-2 border-dashed border-foreground/30 p-10 text-center">
          <p className="text-sm text-muted-foreground">
            You haven't enrolled in any courses yet.
          </p>
          <Link to="/app/student/catalog">
            <Button className="mt-5 rounded-none bg-foreground text-background hard-shadow hover-lift" data-testid="my-courses-browse-btn">
              Browse Catalogue
            </Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map(({ enrollment, course }) =>
            course ? (
              <Link
                key={enrollment.id}
                to={`/app/student/learn/${course.id}`}
                className="group block border-2 border-foreground bg-background overflow-hidden hover-lift"
                data-testid={`my-course-card-${course.slug}`}
              >
                <div className="relative aspect-[16/9] overflow-hidden bg-muted">
                  {course.thumbnail && (
                    <img
                      src={course.thumbnail}
                      alt={course.title}
                      className="h-full w-full object-cover transition-transform group-hover:scale-105"
                    />
                  )}
                  <div className="absolute left-2 top-2 mono bg-foreground px-2 py-0.5 text-[10px] uppercase tracking-widest text-background">
                    {course.category}
                  </div>
                </div>
                <div className="p-5">
                  <div className="font-display text-lg font-extrabold leading-tight tracking-tight">
                    {course.title}
                  </div>
                  <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">
                    {course.short_description}
                  </p>
                  <div className="mt-4">
                    <Progress
                      value={enrollment.progress_pct || 0}
                      className="h-2 rounded-none"
                    />
                    <div className="mono mt-2 flex justify-between text-[10px] uppercase tracking-widest text-muted-foreground">
                      <span>{(enrollment.progress_pct || 0).toFixed(0)}% complete</span>
                      <span>
                        {enrollment.completed_lessons?.length || 0} lessons done
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ) : null
          )}
        </div>
      )}
    </div>
  );
}
